export const framerSidebarBackground = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0, transition: { delay: 0.2 } },
    transition: { duration: 0.3 },
}

export const framerSidebarPanel = {
    initial: { x: '100vw' }, // Start completely off-screen to the right
    animate: { x: '0vw' }, // Move to the right side of the screen
    exit: { x: '100vw' }, // Move back off-screen to the right
    transition: { duration: 0.3 },
}

export const framerText = (delay: any) => {
    return {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: {
            delay: 0.5 + delay / 10,
        },
    }
}